import { cn } from '@src/components/ui';


function SidebarGroup(props) {
  const { className, ...restProps } = props;
  return <ul className={cn('flex flex-col gap-1', className)} {...restProps} />;
}

SidebarGroup.displayName = 'SidebarGroup';
export default SidebarGroup;
